/* eslint-disable max-len */
import { connect } from 'react-redux';
import Home from './Home';

import { fetchStatistic } from '../../actions/currentUserAction';

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  friendRequests: state.friendRequests.length,
});

const mapDispachToProps = (dispatch) => ({
  incomingMessages: (url, typeSuccess, typeError) =>
    dispatch(fetchStatistic({ url, typeSuccess, typeError })),
  outgoingMessages: (url, typeSuccess, typeError) =>
    dispatch(fetchStatistic({ url, typeSuccess, typeError })),
});

export default connect(mapStateToProps, mapDispachToProps)(Home);
